import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";

import { IssueResponse } from "../../api-models/response/IssueResponse";
import { CollapsibleService } from "../../services/collapsible/CollapsibleService";
import Collapsbile from "../collapsible/Collapsbile";
import Svg from "../svg/Svg";
import { Info, Warning, Error } from "../svg/svgImageList";
import "./GenericObjectIssues.scss";
import { IssueSeverity } from "../../generated/SewerObjects";

interface GenericObjectIssuesProps {
  collapsibleService: CollapsibleService;
  genericIssues: IssueResponse[];
}

export default observer(function GenericObjectIssues(props: GenericObjectIssuesProps) {
  const { genericIssues } = props;

  const orderedIssuesBySeverity = useMemo(() => {
    const errors = genericIssues.filter((x) => x.severity === IssueSeverity.Error);
    const warnings = genericIssues.filter((x) => x.severity === IssueSeverity.Warning);
    const info = genericIssues.filter((x) => x.severity === IssueSeverity.Info);

    return errors.concat(warnings).concat(info);
  }, [genericIssues]);

  const topLevelGenericIssueTranslationKey = useMemo(() => {
    if (genericIssues.filter((x) => x.severity === IssueSeverity.Error)?.length)
      return `generic-issue-validation.${IssueSeverity[IssueSeverity.Error]}`;
    if (genericIssues.filter((x) => x.severity === IssueSeverity.Warning)?.length)
      return `generic-issue-validation.${IssueSeverity[IssueSeverity.Warning]}`;
    if (genericIssues.filter((x) => x.severity === IssueSeverity.Info)?.length)
      return `generic-issue-validation.${IssueSeverity[IssueSeverity.Info]}`;
    return "";
  }, [genericIssues]);

  return (
    <>
      {orderedIssuesBySeverity?.length > 0 && (
        <div className="generic-issues-container">
          <Collapsbile
            collapsibleService={props.collapsibleService}
            titleKey={topLevelGenericIssueTranslationKey}
          >
            {orderedIssuesBySeverity?.map((x: IssueResponse) => {
              return (
                <div key={x.message} className="generic-issue">
                  {x.severity === IssueSeverity.Error && (
                    <Svg className="issues error" svg={Error} />
                  )}
                  {x.severity === IssueSeverity.Warning && (
                    <Svg className="issues warning" svg={Warning} />
                  )}
                  {x.severity === IssueSeverity.Info && <Svg className="issues info" svg={Info} />}
                  <span className="issue-message">{x.message}</span>
                </div>
              );
            })}
          </Collapsbile>
        </div>
      )}
    </>
  );
});
